import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import getOut from '../../sounds/ulos.m4a'
import Noppa from '../../additionalComponents/Noppa.js';
import d3 from './images/d3.gif'
import { data } from './data/data_01_AC_sinuteltu'
// import kuva from './images/slightly_pissed.jpg'
import kuva from './images/slightly_pissed_300x430.png'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Scene_01_AC_sinuteltu = ({ visibilityHandler, soundsOn }) => {
    const [teksti, setTeksti] = useState('')
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [tarvittavaNopanArvo, setTarvittavaNopanArvo] = useState(null)
    const [noppaMsg, setNoppaMsg] = useState('')
    const [continuable, setContinuable] = useState(false)
    const [nextScene, setNextScene] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [closeActive, setCloseActive] = useState(false);

    const [playGetOut] = useSound(getOut);

    const handleClose = () => setShowModal(false);
    const handleShowModal = () => {
        setShowModal(true);
        setCloseActive(false)
    }

    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {

        setTarvittavaNopanArvo(data.tarvittavaNoppaluku)
        setNoppaMsg(data.noppaMsg)
        setTeksti(data.teksti)
    }, [])


    const handleJatka = () => {

        if (nextScene != '') {
            visibilityHandler(nextScene)
        }

    }


    const handlaaArvontatulos = (e) => {
        if (e >= tarvittavaNopanArvo) {
            setNextScene('scene_01_epilogi')
        }
        else {
            // playGetOut()
            setNextScene('ulos')
        }
        setCloseActive(true)//aktivoi modaalin sulkunapin
        setContinuable(true)

    }


    return (

        <div className='sceneContainer'>
            <div id='image' className='kuvaBox'>
                <img className='fitted' src={kuva} alt='kuva' />

            </div>

            <div id='question'>
                <h4>{(teksti != null && teksti != "") ? teksti : null}</h4>
                <div>
                    <br />

                    <br />
                    {noppaMsg + tarvittavaNopanArvo}
                    <br />


                    {/* <> */}

                    {/* <Button variant="primary" onClick={handleShowModal}>
                            Heitä noppaa
                        </Button> */}
                    {/* </> */}



                    <br />

                    {nextScene}
                </div>
            </div>

            <div id='actiions'>

                <div>
                    <Modal
                        show={showModal}
                        onHide={handleClose}
                        backdrop="static"
                        keyboard={false}
                    >


                        {/* <Modal.Header closeButton>
                                <Modal.Title>Modal title</Modal.Title>
                            </Modal.Header> */}
                        <Modal.Body>
                            <Noppa
                                soundsOn={soundsOn}
                                handlaa={handlaaArvontatulos}
                                tarvittavaNopanArvo={tarvittavaNopanArvo}
                            // sulku={handleClose}
                            />


                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}
                                disabled={!closeActive}
                            >
                                Close
                            </Button>

                        </Modal.Footer>
                    </Modal>
                </div>

                <img src={d3} alt='noppa_3' onClick={handleShowModal} style={{ width: '50px' }} />

                <div>
                    <Button disabled={!continuable} onClick={() => handleJatka()}>Jatka</Button>
                </div>
            </div>
        </div>
    )

}


export default Scene_01_AC_sinuteltu